<template>
  <footer class="registration-footer">
    <div class="registration-footer__title">
      <BaseLine />
      <span>Уже есть аккаунт?</span>
      <BaseLine />
    </div>
    <BaseGhostButtonLink href="/signin/" target="_blank" class="--m">
      войти в мтс линк
    </BaseGhostButtonLink>
  </footer>
</template>

<script>
import BaseGhostButtonLink from '@/components/NewDesign/Common/Base/BaseGhostButtonLink.vue'
import BaseLine from '@/components/NewDesign/Common/Base/BaseLine.vue'

export default {
  name: 'RegistrationFooter',
  components: { BaseLine, BaseGhostButtonLink },
}
</script>

<style scoped lang="scss">
.registration-footer {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;

  @include screen-up('lg') {
    display: none;
  }

  @include screen-down('md') {
    gap: 0;
  }

  &__title {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 10px;

    span {
      font-family: $font-mts-compact;
      font-size: 17px;
      line-height: 24px;
      color: $color-black;
      white-space: nowrap;
    }
  }
}
</style>
